/*
  NODO : aucune variante présélectionnée.
  Au chargement d'une fiche produit (ou d'une section produit vedette) SANS ?variant= dans l'adresse,
  les menus affichent « Choisissez... », la photo de la variante est cachée et le bouton d'achat
  reste désactivé tant que toutes les options ne sont pas choisies. Dès que tout est choisi,
  le thème (Dawn/Sense) reprend son fonctionnement normal.
*/
(function () {
  if (window.__nodoNoPreselect) return;
  window.__nodoNoPreselect = true;

  var isEn = (document.documentElement.lang || 'fr').toLowerCase().indexOf('en') === 0;
  var T = isEn
    ? { pick: 'Select an option', button: 'Choose your options', error: 'Please choose all options before adding to cart.' }
    : { pick: 'Choisissez une option', button: 'Choisissez vos options', error: 'Veuillez choisir toutes les options avant d’ajouter au panier.' };

  var style = document.createElement('style');
  style.textContent = '.nodo-hidden{display:none!important}';
  document.head.appendChild(style);

  function sectionIdOf(pi) {
    return pi.dataset.section || pi.getAttribute('data-section') || '';
  }

  function isComplete(vs) {
    var selects = vs.querySelectorAll('select');
    for (var i = 0; i < selects.length; i++) if (!selects[i].value) return false;
    var fieldsets = vs.querySelectorAll('fieldset');
    for (var j = 0; j < fieldsets.length; j++) {
      if (fieldsets[j].querySelector('input[type="radio"]') && !fieldsets[j].querySelector('input[type="radio"]:checked')) return false;
    }
    return true;
  }

  function setSwatchPreview(select) {
    var box = select.closest('.product-form__input');
    box = box && box.querySelector('[data-selected-value] > .swatch');
    if (!box) return;
    var opt = select.selectedOptions[0];
    var sw = opt && opt.dataset.optionSwatchValue;
    if (sw) {
      box.style.setProperty('--swatch--background', sw);
      box.classList.remove('swatch--unavailable');
    } else {
      box.style.setProperty('--swatch--background', 'unset');
      box.classList.add('swatch--unavailable');
    }
  }

  function lockForm(pi) {
    var sid = sectionIdOf(pi);
    pi.querySelectorAll('form[data-type="add-to-cart-form"] input[name="id"]').forEach(function (input) {
      input.dataset.nodoOriginal = input.value;
      input.value = '';
    });
    pi.querySelectorAll('button[name="add"]').forEach(function (btn) {
      btn.setAttribute('disabled', 'disabled');
      var span = btn.querySelector('span');
      if (span) span.textContent = T.button;
    });
    pi.querySelectorAll('.shopify-payment-button, [data-shopify="payment-button"]').forEach(function (el) {
      el.classList.add('nodo-hidden', 'nodo-locked');
    });
    // Cacher la photo de la variante présélectionnée par le thème (les photos générales restent).
    var json = pi.querySelector('variant-selects script[type="application/json"]');
    var variant = null;
    try { variant = json ? JSON.parse(json.textContent) : null; } catch (e) {}
    var mediaId = variant && variant.featured_media && variant.featured_media.id;
    if (mediaId && sid) {
      var slide = pi.querySelector('li[data-media-id="' + sid + '-' + mediaId + '"]');
      var gallery = pi.querySelector('media-gallery ul');
      var slides = gallery ? gallery.querySelectorAll('li[data-media-id]') : [];
      // Ne cacher que si la photo de variante n'est pas la seule photo
      if (slide && slides.length > 1) {
        slide.classList.add('nodo-hidden', 'nodo-locked');
        var thumb = pi.querySelector('.thumbnail-list li[data-target="' + sid + '-' + mediaId + '"]');
        if (thumb) thumb.classList.add('nodo-hidden', 'nodo-locked');
      }
    }
    pi.querySelectorAll('[data-selected-value]').forEach(function (el) {
      if (!el.querySelector('.swatch')) {
        el.dataset.nodoText = el.textContent;
        el.textContent = '';
        el.classList.add('nodo-locked-text');
      }
    });
  }

  function unlock(pi) {
    pi.dataset.nodoDone = '1';
    pi.querySelectorAll('.nodo-locked').forEach(function (el) {
      el.classList.remove('nodo-hidden', 'nodo-locked');
    });
  }

  function init(pi) {
    if (pi.dataset.nodoInit) return;
    var vs = pi.querySelector('variant-selects');
    if (!vs) return;
    var controls = vs.querySelectorAll('select, fieldset input[type="radio"]');
    if (!controls.length) return;
    pi.dataset.nodoInit = '1';

    vs.querySelectorAll('select').forEach(function (select) {
      Array.prototype.forEach.call(select.options, function (o) {
        o.removeAttribute('selected');
        o.selected = false;
      });
      var label = vs.querySelector('label[for="' + select.id + '"]');
      var ph = document.createElement('option');
      ph.value = '';
      ph.disabled = true;
      ph.textContent = (label && label.textContent.trim()) || T.pick;
      ph.setAttribute('selected', 'selected');
      ph.dataset.nodoPlaceholder = '1';
      select.insertBefore(ph, select.firstChild);
      select.value = '';
      ph.selected = true;
      setSwatchPreview(select);
    });
    vs.querySelectorAll('fieldset input[type="radio"]').forEach(function (r) {
      r.checked = false;
      r.removeAttribute('checked');
    });
    lockForm(pi);
  }

  // Bloque la mise à jour du thème tant que toutes les options ne sont pas choisies.
  document.addEventListener(
    'change',
    function (e) {
      var vs = e.target.closest && e.target.closest('variant-selects');
      if (!vs) return;
      var pi = vs.closest('product-info');
      if (!pi || pi.dataset.nodoInit !== '1' || pi.dataset.nodoDone) return;

      var t = e.target;
      if (t.tagName === 'SELECT') {
        Array.prototype.forEach.call(t.options, function (o) { o.removeAttribute('selected'); });
        if (t.selectedOptions[0]) t.selectedOptions[0].setAttribute('selected', 'selected');
        setSwatchPreview(t);
      }
      var shown = t.closest('.product-form__input');
      var text = shown && shown.querySelector('.nodo-locked-text');
      if (text && t.type === 'radio') text.textContent = t.value;

      if (!isComplete(vs)) {
        e.stopPropagation();
        return;
      }
      // Tout est choisi : on laisse le thème faire son travail normal.
      pi.querySelectorAll('.nodo-locked-text').forEach(function (el) { el.classList.remove('nodo-locked-text'); });
      unlock(pi);
    },
    true
  );

  // Sécurité : jamais d'ajout au panier sans variante choisie.
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || form.getAttribute('data-type') !== 'add-to-cart-form') return;
      var input = form.querySelector('input[name="id"]');
      if (input && !input.value) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var pf = form.closest('product-form');
        if (pf && pf.handleErrorMessage) pf.handleErrorMessage(T.error);
      }
    },
    true
  );

  function run() {
    if (/[?&]variant=/.test(window.location.search)) {
      // Lien direct vers une variante (Google Shopping, partage) : comportement normal sur la fiche principale.
      document.querySelectorAll('product-info').forEach(function (pi) {
        if (pi.dataset.updateUrl !== 'false') pi.dataset.nodoInit = 'skip';
      });
    }
    document.querySelectorAll('product-info').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
